// Recovered compiled webpack factory 37822. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { X4: () => r, ai: () => s, hs: () => o });
  var n = i(48895);
  let s = { test: (t) => "number" == typeof t, parse: parseFloat, transform: (t) => t },
    r = { ...s, transform: (t) => (0, n.q)(0, 1, t) },
    o = { ...s, default: 1 };
}
